<script setup lang="ts"></script>

<template>
  <section class="popover-wrapper">
    <slot></slot>
  </section>
</template>

<style scoped lang="scss">
.popover-wrapper {
  background-color: #fff;
  border-radius: 20px;
  margin-bottom: 20px;
}
</style>
